import { IsBoolean } from 'class-validator';

export class PublicProfileActivityUpdateManagementModel {
  @IsBoolean()
  public active: boolean;

  constructor(
    active: boolean
  ) {
    this.active = active;
  }
}
